<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi Familiare" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiFamiliare.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiFamiliare.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>                        
                        <!-- <b-button v-if="!isReadOnly" @click="onSaveAnamnesiFamiliare"  variant="outline-success">Salva</b-button> -->
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataAnamnesiFamiliare.id" @click="onSaveAnamnesiFamiliare"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiFamiliare: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiFamiliare: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiFamiliare: "/rsaschedarelazionesanitariaanamnesifamiliare",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiFamiliare() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiFamiliare + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiFamiliare = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiFamiliare = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onSaveAnamnesiFamiliare() {
            let me = this;
            me.jsonDataAnamnesiFamiliare.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiFamiliare.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiFamiliare, me.jsonDataAnamnesiFamiliare, me.saveSchedaRelazioneSanitariaAnamnesiFamiliareSuccessResponse, me.saveSchedaRelazioneSanitariaAnamnesiFamiliareErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiFamiliareSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Anamnesi familiare salvata con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaAnamnesiFamiliareErrorResponse() {
            console.error("Errore nel salvataggio anamnesi familiare:");
        },
    },
};
</script>
